'use client';

import React, { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useSubnavData } from '@/ui/providers/subnavDataProvider';

export default function SubnavClearer() {
  const { subnavData, setSubnavData } = useSubnavData();
  const pathName = usePathname();
  useEffect(() => {
    setSubnavData(null);
  }, [pathName, setSubnavData]);
  return null;
}
